import React from 'react';
import TextField from '../../../../../../../Inputs/TextField';

import styles from '../../../PatientDetailesStep/PatientDetailesForm/index.module.scss'

import { Button, Divider } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { IEpicSearchParams } from '../../../../../../../../services/intakeDataService/emrPatientsService';
import BasicBlock from '../../../PatientDetailesStep/PatientDetailesForm/GeneralInformation/BasicBlock';
import GenderField from '../../../PatientDetailesStep/PatientDetailesForm/GeneralInformation/GenderField';
import { GENDER_OPTIONS } from '../../../../hooks/intake-options';

interface IEpicSearchParamsForm {
    firstName: string;
    lastName: string;
    gender: number;
    dateOfBirth: string;
    identifier: string;
}

export default function ({ updateSearchParams }: { updateSearchParams: (params: IEpicSearchParams) => void }) {
    const methods = useForm<IEpicSearchParamsForm>();
    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = methods;

    const onSubmit = (data: IEpicSearchParamsForm) => {
        const new_data: IEpicSearchParams = {
            identifier: data.identifier,
            given: data.firstName,
            family: data.lastName,
            legalSex: GENDER_OPTIONS.find(x => x.value === data.gender)?.label,
            birthDate: data.dateOfBirth,
        }
        updateSearchParams(new_data)
    }

    return <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.sections}>
                <div className={styles.sectionWrapper}>
                    <div className={styles.filedsWrapper} style={{ gap: '1rem' }}>
                        <TextField
                            placeholder="Enter MRN or external Id"
                            error={!!errors?.identifier}
                            helperText={errors?.identifier?.message}
                            hideErrorIcon
                            variant="outlined"
                            wrapperClassName={styles.inputWrapper}
                            inputClassName={styles.inputField}
                            {...register('identifier')}
                        />
                        <Divider>Or</Divider>

                        <BasicBlock required={false} />
                        <GenderField required={false} />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size={'large'}
                            disabled={!isValid}>
                            Search
                        </Button>
                    </div>
                </div>
            </div>

        </form>

    </FormProvider>
}